module.exports = __webpack_public_path__ + "static/media/city3.d50a28d0.jpg";